import { graphql } from '@/gql'

export const OrganisationTrustedContactViewQuery = graphql(/* GraphQL */ `
  query OrganisationTrustedContactView($companyId: ID!, $workerId: ID!, $trustedContactId: ID!) {
    trustedContact: organisationTrustedContact(id: $trustedContactId) {
      ...TrustedContactViewFragment
    }
    conversations(accounts: [$companyId, $workerId]) {
      data {
        ...ConversationsViewFragment
      }
    }
  }
`)

export const TrustedContactsViewQuery = graphql(/* GraphQL */ `
  query TrustedContactsView($companyId: ID!, $workers: [ID!]) {
    trustedContacts(accounts: [$companyId], workers: $workers) {
      data {
        ...TrustedContactViewFragment
      }
    }
    organisationTrustedContacts(accounts: [$companyId], workers: $workers) {
      data {
        ...TrustedContactViewFragment
      }
    }
  }
`)

export const ContactDetailConversationQuery = graphql(/* GraphQL */ `
  query ContactDetailConversationQuery($workerId: ID!, $companyId: ID!) {
    conversations(accounts: [$companyId, $workerId]) {
      data {
        ...ConversationsViewFragment
      }
    }
  }
`)
